import { IonicModule, ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SafeUrlPipe } from '../../../mnt/common/pipes/safe/safe.pipe';
import { register } from 'swiper/element/bundle';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { Swiper } from 'swiper';
import { SwiperOptions } from 'swiper/types';

/**
 * Component : Gallerie photo
 *
 * Permet d'afficher une liste de photos, et d'ajouter une photo, et de gerer les actions sur le click des photos
 *
 * @export
 * @class GalleryComponent
 */

@Component({
  selector: 'img-viewer',
  templateUrl: 'imgviewer.component.html',
  styleUrls: ['imgviewer.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule, SafeUrlPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ImgViewerComponent implements OnInit {
  picture: { contenu: string };
  swiper?: Swiper;
  swiperParams: SwiperOptions = {
    centeredSlides: true,
    slidesPerView: 'auto',
    zoom: true,
  };

  /**
   * Constructeur
   *
   **/
  constructor(private viewCtrl: ModalController) {}

  ngOnInit(): void {
    register();
  }

  swiperReady() {
    this.swiper = new Swiper('.swiper', this.swiperParams);
  }

  close(): void {
    this.viewCtrl.dismiss();
  }
}
